<template>
  <div class="box" :class="mediumClass" @keyup.prevent.enter="playThis">
    <div class="handle" />
    <header>
      {{ medium.title }}
      <div class="settings" v-if="!locked">
        <button @click="settingsToggled = !settingsToggled">
          <div class="dashicons" :class="settingsToggled ? 'dashicons-arrow-up-alt2' : ' dashicons-arrow-down-alt2'" />
        </button>
        <div v-if="settingsToggled" class="settingsMenu">
          <ul>
            <li>
              <a
                href="#edit"
                @click.prevent="editing = true">
                <div class="dashicons dashicons-edit" /> Edit
              </a>
            </li>
            <li>
              <a
                href="#delete" 
                @click.prevent="destroyMedia(medium.id)">
                <div class="dashicons dashicons-no" /> Delete
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <MediaControlsAudio ref="controls" v-if="medium.type === 'audio'" :medium="medium" />
    <MediaControlsVideo ref="controls" v-else-if="medium.type === 'video'" :medium="medium" />
    <MediaControlsImage ref="controls" v-else-if="medium.type === 'image'" :medium="medium" />
    <MediaControlsLink ref="controls" v-else-if="medium.type === 'link'" :medium="medium" />
    <MediaEdit :reset="medium" v-if="editing" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MediaEdit from '@/components/MediaEdit'
import MediaControlsAudio from '@/components/MediaControlsAudio'
import MediaControlsVideo from '@/components/MediaControlsVideo'
import MediaControlsImage from '@/components/MediaControlsImage'
import MediaControlsLink from '@/components/MediaControlsLink'

export default {
  name: "MediaBox",
  props: {
    medium: Object
  },
  components: {
    MediaEdit,
    MediaControlsAudio,
    MediaControlsVideo,
    MediaControlsImage,
    MediaControlsLink
  },
  data: () => ({
    editing: false,
    settingsToggled: false
  }),
  methods: {
    playThis() {
      this.$refs.controls.toggle()
    },
    ...mapActions([
      'destroyMedia'
    ])
  },
  computed: {
    mediumClass() {
      const classes = []
      if (this.medium.type) classes.push(this.medium.type)
      if (this.medium.color) classes.push(this.medium.color)
      if (this.locked) classes.push('locked')
      return classes.join(' ')
    },
    ...mapState([
      'locked'
    ])
  },
  watch: {
    editing() {
      this.settingsToggled = false
    }
  }
};
</script>

<style lang="stylus">
</style>
